module.exports = __webpack_public_path__ + "img/Onboarding_Asset_1.625b52a3.svg";